export default __webpack_public_path__ + "static/smuacademy-58427fa3663f45a68f8f64c54f09580a.png";